import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import MD5 from "crypto-js/md5";
import dayjs from 'dayjs';
import { apiRequest } from '../../../../app/Apis';
import { appLog } from "../../../../common/helpers";


const timezone = require('dayjs/plugin/timezone');

dayjs.extend(timezone)

export const Rcopia = ({ activeUser, patient }) => {
    const [time, settime] = useState(dayjs().tz('GMT').format('MMDDYYHHmmss'))
    useEffect(() => {

        LogSSOAttempt()
        return () => {

        }
    }, [])
    const param_string = `rcopia_portal_system_name=${activeUser.rcopia_vendor_and_practice.vendor_username}&rcopia_practice_user_name=${activeUser.rcopia_vendor_and_practice.practice_username}&rcopia_user_id=${activeUser.rcopia_username}&rcopia_user_external_id=${activeUser.id}&service=rcopia&action=login&startup_screen=patient&rcopia_patient_id=${patient.rcopia_id}&rcopia_patient_external_id=${patient.id}&time=${time}${activeUser.rcopia_vendor_and_practice.vendor_password}`

    const LogSSOAttempt = async () => {
        let payload = {
            "message": "SSO Login Attempt Patient Prescriptions",
            "level_name": "INFO",
            "context": {
                "payload": param_string,
                "consultant": activeUser.name,
                "patient": patient.name
            }
        }
        const data = await apiRequest.post("/integrations/dr_first/sso_logs", payload).catch(err => console.log(err))
        if (data && data.data) {
            console.log("done")
        }
    }



    return (
        <div className='rcopia-iframe' style={{ width: "100%", height: '70vh' }}>
            {/* {time} */}
            <iframe src={`${process.env.REACT_APP_DR_FIRST_URL}?rcopia_portal_system_name=${activeUser.rcopia_vendor_and_practice.vendor_username}&rcopia_practice_user_name=${activeUser.rcopia_vendor_and_practice.practice_username}&rcopia_user_id=${activeUser.rcopia_username}&rcopia_user_external_id=${activeUser.id}&service=rcopia&action=login&startup_screen=patient&rcopia_patient_id=${patient.rcopia_id}&rcopia_patient_external_id=${patient.id}&time=${time}&MAC=${MD5(param_string).toString().toUpperCase()}`} frameborder="0"></iframe>
        </div>
    )
}

const mapStateToProps = (state) => ({
    activeUser: state.auth?.activeUser,
    patient: state.patients.selectedPatient,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Rcopia)
